export default __webpack_public_path__ + "static/media/logo-direita.3676295a.jpg";